import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";
import { Field, TextInput, SubmitButton } from "@/components/forms";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vc_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl bg-white p-8 shadow-lift sm:p-10" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-8 font-display text-2xl font-800 tracking-tight text-navy">Admin Sign In</h1>
        <p className="mt-1 text-sm text-slate-500">Victory Chapel content management</p>
        <div className="mt-7 space-y-5">
          <Field label="Email" id="ad-email" required>
            <TextInput id="ad-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
          </Field>
          <Field label="Password" id="ad-password" required>
            <TextInput id="ad-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          </Field>
        </div>
        <div className="mt-7">
          <SubmitButton testId="admin-login-submit" loading={loading}>SIGN IN</SubmitButton>
        </div>
      </form>
    </div>
  );
}
